import { createAction, props } from '@ngrx/store';

export const loadDownloadPayrollChangesDocuments = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollChangesDocuments',
  props<{ businessId: string; paymentDueDate: string; payrollChangeFileName: string }>()
);

export const loadDownloadPayrollChangesDocumentsSuccess = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollChangesDocuments Success',
  props<{ response: any }>()
);

export const loadDownloadPayrollChangesDocumentsFailure = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollChangesDocuments Failure',
  props<{ error: Error | any }>()
);
